import { useCallback, useEffect, useRef, useState } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import { Table, Loader, CustomTab, BackButton } from 'src/components';
import { baseApiCall } from 'src/api/Api';
import { dashboard_alerts } from 'src/constants/url';
import { alertsHeader } from './constant';
import globalstyle from 'src/assets/scss/global.module.scss';
import styles from './Alerts.module.scss';
import { useSelector } from 'react-redux';
import AlertRadioButton from 'src/components/Atoms/AlertRadioButton/AlertRadioButton';
import { useDispatch } from 'react-redux';
import { alertsCount, filterDates } from 'src/redux/features';
import { Title, commonVaribles } from 'src/constants/constVariables';
import moment from 'moment';

export const Alerts = () => {
	const navigate = useNavigate();
	const location = useLocation();
	const [alertList, setAlertsList] = useState([]);
	const [totalData, setTotalData] = useState(0);
	const [checkedState, setCheckedState] = useState([]);
	const [selectedRows, setSelectedRows] = useState([]);
	const [allSelectedRows, setAllSelectedRows] = useState(false);
	const [checkedStateAll, setCheckedStateAll] = useState(false);
	const [selectCount, setSelectCount] = useState(0);
	const [offset, setOffset] = useState(-1);
	const [loader, setLoader] = useState(true);
	const [loaderTbl, setLoaderTbl] = useState(true);
	const startUTC = moment(new Date()).startOf('day').utc().format();
	const endUTC = moment(new Date()).endOf('day').utc().format();
	const [startDate, setStartDate] = useState(startUTC);
	const [endDate, setEndDate] = useState(endUTC);

	const countRef = useRef(0);
	const dispatch = useDispatch();
	dispatch(filterDates([startDate, endDate]));
	const SelectedShop = useSelector((state) => state.allshops.shopName?.value);
	const SelectedLine = useSelector((state) => state.allLine.lineName?.value);
	const timeintervalforAlert = useSelector(
		(state) => state.user.timeTnterval.alert_time_interval
	);

	const selectedShopRef = useRef('');
	const selectedLineRef = useRef('');
	const startDateRef = useRef(startDate);
	const endDateRef = useRef(endDate);
	const ToggleRef = useRef(false);
	useEffect(() => {
		setLoaderTbl(true);
		fetchAlertsList(
			startDate,
			endDate,
			SelectedShop,
			SelectedLine,
		);
	}, [SelectedShop, SelectedLine, startDate, endDate]);

	useEffect(() => {
		selectedShopRef.current = SelectedShop;
		selectedLineRef.current = SelectedLine;
		startDateRef.current = startDate;
		endDateRef.current = endDate;
	}, [SelectedShop, SelectedLine, startDate, endDate]);

	useEffect(() => {
		const fetchSequencingReportListInterval = setInterval(() => {
			fetchAlertsList(
				startDateRef.current,
				endDateRef.current,
				selectedShopRef.current,
				selectedLineRef.current,
				ToggleRef.current
			);
		}, timeintervalforAlert);
		return () => {
			clearInterval(fetchSequencingReportListInterval);
		};
	}, [timeintervalforAlert]);

	useEffect(() => {
		setCheckedState((prev) => {
			return [...new Array(alertList.length).fill(checkedStateAll)];
		});
	}, [checkedStateAll]);

	useEffect(() => {
		setSelectCount(checkedState.filter((value) => value === true).length);
	}, [checkedState]);

	const increaseOffset = useCallback(() => {
		setOffset(offset + 1);
	}, [offset]);

	const increaseRef = useCallback(() => {
		countRef.current = countRef.current + 1;
	}, [countRef]);

	const fetchAlertsList = (
		startDate,
		endDate,
		SelectedShop,
		SelectedLine,
		toggleStatus
	) => {
		baseApiCall({
			url: dashboard_alerts.GET_ALERTS_LIST,
			requestBody: {
				start_date: startDate?.length > 0 ? startDate : '',
				end_date: endDate?.length > 0 ? endDate : '',

			},
			method: commonVaribles.post,
			onSuccess: (res) => {
				if (res && res.data && res.data.result) {
					const data = res.data.result.alert_data;
					const count = res.data.result.total_count;
					dispatch(alertsCount(count));
					const modifiedData = data.map((item) => ({
						...item,
						is_action: (
							<AlertRadioButton
								value={item.is_action}
								rowData={item}
								onCheckChange={() =>
									fetchAlertsList(
										startDate,
										endDate,
										SelectedShop,
										SelectedLine,
										toggleStatus
									)
								}
							/>
						),
					}));
					setAlertsList(modifiedData);
					increaseRef();
					increaseOffset();
					setLoader(false);
					setLoaderTbl(false);
					setSelectedRows([
						...selectedRows,
						...new Array(data.length).fill(false),
					]);
					if (offset !== 0) {
						let temp = [...alertList];
						data.forEach((element) => {
							temp.push(element);
						});
						setTotalData(data.length);
					} else {
						setAlertsList(modifiedData);
						setTotalData(data.length);
					}
				} else {
					setLoader(false);
					setLoaderTbl(false);
					setAlertsList([]);
				}
			},
			onFailure: (res) => {
				setLoader(false);
				setLoaderTbl(false);
			},
			invalidCall: (res) => {
				setLoader(false);
				setLoaderTbl(false);
			},
			errorCall: (res) => {
				setLoader(false);
				setLoaderTbl(false);
			},
		});
	};

	const handleCheckbox = () => {
		setCheckedStateAll((prev) => {
			return !prev;
		});
	};

	const handleSingleCheckbox = (position, e) => {
		setCheckedState((prev) => {
			let a = [];
			if (prev.length === 0) {
				alertList?.map((item, index) =>
					index === position ? a.push(true) : a.push(false)
				);
			} else {
				prev?.map((item, index) =>
					index === position ? a.push(!item) : a.push(item)
				);
			}
			return [...a];
		});
	};

	const updateSetSelectedRows = async (pos, data, ind) => {
		if (pos === commonVaribles.all) {
			let ab = [];
			setAllSelectedRows(!allSelectedRows);
			ab = alertList.map((row, index) => {
				const isSelected = !data.every((row) => row.isSelected);
				if (ind.includes(index) && isSelected) {
					return true;
				} else {
					return false;
				}
			});
			ab
				? setSelectedRows(ab)
				: setSelectedRows([
						...selectedRows,
						...new Array(data.length).fill(false),
					]);
		} else {
			setSelectedRows((prev) => {
				let a = [];
				prev.map((item, index) =>
					index === pos ? a.push(!item) : a.push(item)
				);
				return [...a];
			});
		}
	};

	const dateSetter=(newStartDate,newEndDate)=>{
		setStartDate(newStartDate);
		setEndDate(newEndDate);
	}

	async function dateClearFilter() {
		setStartDate('');
		setEndDate('');
		return {
			defaultStartDate: '',
			defaultEndDate: '',
		};
	}

	return (
    <>
      {!loader ? (
        <div className={styles.tablecontainer}>
          <div className={globalstyle.breadcrumb}>
            <BackButton
              basePath={Title.home}
              action={Title.alerts}
              handleClick={() => {
                navigate("/");
              }}
              browserBack={true}
            />
          </div>
          <div>
            <CustomTab
              title={Title.alerts}
              count={totalData}
              isAlerts={true}
              isSearchBar={false}
              isDatepicker
              // handleChange={(e) => setnotMappedVC(e)}
			  onChangeDatefilter={dateSetter}
              dateClearFilter={dateClearFilter}
              startDate={startDate}
              endDate={endDate}
              // toggleState={notMappedVC}
            />
          </div>
          <div className={styles.tablemain}>
            <Table
              columns={[...alertsHeader]}
              defaultColumns={[...alertsHeader]}
              rows={alertList}
              rowHeight={38}
              setAsnCount={() => {}}
              removeRowSelection={false}
              pagination={false}
              infiniteScroll={false}
              setTotalData={setTotalData}
              handleSingleCheckbox={(e) => handleSingleCheckbox(e)}
              selectedRows={selectedRows}
              selectCount={selectCount}
              isAlertTable={true}
              updateSetSelectedRows={updateSetSelectedRows}
              handleCheckbox={handleCheckbox}
              onChangeFilterResetTheCheckbox={() => {}}
              isDataLoading={loaderTbl}
            />
          </div>
        </div>
      ) : (
        <div className={styles["loader-div"]}>
          <Loader />
        </div>
      )}
      <style jsx="true">
        {`
          a {
            text-decoration: none;
            color: inherit;
          }
        `}
      </style>
    </>
  );
};
